module.exports = __webpack_public_path__ + "static/media/scenery-mobile.2db7dc9e.svg";